import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilitiesService } from '../../services/utilities.service';
import { ProfileService } from '../../services/profile.service';
import { catchError, map, of } from 'rxjs';

export const fdUserGuardOnboarding: CanActivateFn = (route) => {
  const profileService = inject(ProfileService);
  const utilities = inject(UtilitiesService);
  const router = inject(Router);

  const clientId =
    route.paramMap.get('clientId') ?? utilities.clientId;

  return profileService.getProfileCached().pipe(
    map((response: any) => {
      const role = response.profile.role;
      const permittedRoles = ['system_admin', 'fd_admin', 'fd_user', 'partner_onboarding_user', 'merchant_admin', 'demo_client_admin_w_onboarding_wizard'];
      const isFdUser = permittedRoles.includes(role);

      utilities.setIsFdUser(isFdUser);

      if (isFdUser) {
        return true;
      }

      return router.createUrlTree(['/onboarding-in-process'], {
        queryParams: {
          clientId
        },
      });
    }),
    catchError(() =>
      of(router.createUrlTree(['/select-client']))
    )
  );
};